import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {
    claim: async (missionId, missionEventAvailabilityId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/mission_event_availabilities/" + missionEventAvailabilityId;

        try {
            const response = await fetch(url, {
                method: "PATCH",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },


}